<template>
  <button class="Drop-Menu-Item" @click="toStartDeleteProcess">
    <div class="Drop-Menu-Item__svg-box">
      <DeleteBinIcon />
    </div>
    Удалить
  </button>
</template>

<script setup>
  import { ref, computed, defineProps } from 'vue';
  import { useStore } from 'vuex';
  import { Props } from './scripts/props.js';
  import { deletePost } from './api/deletePost.js';
  import { callOverlay } from '@/Groups/OverlayManager/public/utils/callOverlay.js';
  //--------------------------------------------
  import DeleteBinIcon from '@svg/DeleteBinIcon.vue';
  //--------------------------------------------
  const store = useStore();
  const props = defineProps(Props());
  //--------------------------------------------
  const isLoading = ref(false);
  //--------------------------------------------
  //Получить пост для удаления
  const get_post = computed(() => store.state.ContentSystem.Alpha.list[props.postId]);
  //--------------------------------------------
  //Начать процесс удаления поста
  const toStartDeleteProcess = async() => {
    if(isLoading.value) return;
    try {
      toToggleLoading(true);
      await deletePost({ object_id: get_post.value.id });
      toRemovePostToList();
      callOverlay({ text: 'Пост был успешно удален', color: 'green', icon: 'delete' })
    } catch (error) {
      console.error('Ошибка при попытке пожаловаться на пост', error);
      callOverlay({ text: 'Ошибка при удалении поста', color: 'red', icon: 'delete' })
    } finally{
      toToggleLoading(false);
    }
  }
  //Убрать пост из списка
  const toRemovePostToList = () => store.commit('ContentSystem/Alpha/toRemovePostFromList', get_post.value.id);
  //Переключить состояние процесса удаления поста
  const toToggleLoading = (status) => isLoading.value = status;
</script>

<style lang="scss">
  @import '../../../../styles/Drop-Menu-Item.scss';
</style>